<script setup lang="ts">
import NavBar from '../../components/NavBar.vue';
import AuthProfileHydrationGate from '@/shared/components/Auth/AuthProfileHydrationGate.vue';
import { AppContext } from '@/models/AppContext';
import { computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { isCognitoEnabled } from '@/shared/auth/cognitoFeatureFlag';
import { isPublicCommissioningEntry } from '../../router/utils';
import PhaseMiswire from '../global-popups/PhaseMiswire.vue';
import { useGlobalMessageStore } from '../../stores/globalMessageStore';
import { useProjectStore } from '../../stores/projectStore';
import { initPollings, stopPollings } from '../../utils/init-pollings';

const globalMessageStore = useGlobalMessageStore();
const route = useRoute();
const publicEntry = computed(() => isCognitoEnabled && isPublicCommissioningEntry(route.name));

/**
 * This has to be done here so that the pollings are initialized
 * when the page is refreshed during commissioning process
 */
initPollings();

onMounted(() => {
  globalMessageStore.connect();
  useProjectStore().fetchUserCountryCode();
});

onUnmounted(() => {
  globalMessageStore.disconnect();
  stopPollings();
});
</script>

<template>
  <div class="com-screen">
    <div class="nav-container">
      <NavBar />
    </div>
    <div class="content-container">
      <router-view v-if="publicEntry" />
      <AuthProfileHydrationGate v-else :app-context="AppContext.ComApp">
        <router-view />
      </AuthProfileHydrationGate>
    </div>
    <teleport to="body">
      <PhaseMiswire />
    </teleport>
  </div>
</template>

<style lang="less">
@import '../../assets/style/commissioning';
@import '../../assets/style/antd-overwrites.less';
</style>

<style lang="less" scoped>
.nav-container {
  position: fixed;
  z-index: @z-index-navbar;
  width: 100%;
}

.content-container {
  position: relative;
  top: @com-nav-height;
}
</style>
